import { render } from "./TransactionsPagination.vue?vue&type=template&id=9d5f5a58&scoped=true"
import script from "./TransactionsPagination.vue?vue&type=script&lang=js"
export * from "./TransactionsPagination.vue?vue&type=script&lang=js"

import "./TransactionsPagination.vue?vue&type=style&index=0&id=9d5f5a58&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_clean-css@5.3.3_c_b42aad1f9cb297798e408b604a7fd1c5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5f5a58"]])

export default __exports__